import React from 'react'

import { FieldKit } from 'containers/FormBuilder'
import { FormikValues } from 'formik'

import { DEFAULT_MARINE_COLLATERAL_VALUES } from '../../form/fields/marineWriteInFields'
import EngineFormSubsection from './writeInFields/EngineFormSubsection'
import HullFormSubsection from './writeInFields/HullFormSubsection'
import TotalAmountSection from './writeInFields/TotalAmountSection'
import TrailerFormSubsection from './writeInFields/TrailerFormSubsection'

interface Props {
    formik: FieldKit<FormikValues>
    prefilled?: boolean
}

function MarineWriteIn({ formik, prefilled }: Readonly<Props>) {
    const { repower, hull, engines } = formik.values.marine

    const condition = repower
        ? (engines?.[0]?.condition ??
          DEFAULT_MARINE_COLLATERAL_VALUES.condition)
        : (hull?.condition ?? DEFAULT_MARINE_COLLATERAL_VALUES.condition)

    const subsectionProps = {
        formik,
        prefilled,
    }

    return (
        <>
            {!repower && <HullFormSubsection {...subsectionProps} />}
            <EngineFormSubsection {...subsectionProps} />
            {!repower && <TrailerFormSubsection {...subsectionProps} />}
            <TotalAmountSection
                formik={formik}
                prefilled={prefilled}
                condition={condition}
            />
        </>
    )
}

export default MarineWriteIn
